import Swiper, { Keyboard, Navigation, Autoplay } from 'swiper';
import SwiperCore from 'swiper';

export function projectSlider() {
  const $slider = $('.home-projects-slider');
  if (!$slider || $slider.length === 0) return;

  SwiperCore.use([Navigation, Keyboard, Autoplay]);

  const swiper = new Swiper('.home-projects-slider', {
    navigation: {
      nextEl: '.home-projects-slider-next',
      prevEl: '.home-projects-slider-prev',
    },

    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },

    autoplay: {
      delay: 4000,
      disableOnInteraction: false,
      pauseOnMouseEnter: true,
    },

    speed: 1200,

    loop: true,

    roundLengths: true,

    observer: true,
    observeParents: true,

    watchSlidesProgress: true,

    breakpoints: {
      0: {
        slidesPerView: 1,
        slidesPerGroup: 1,
        spaceBetween: 0,
      },

      768: {
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 30,
      },
      1440: {
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
      },
      1940: {
        slidesPerView: 'auto',
        slidesPerGroup: 1,
        spaceBetween: 30,
        autoplay: {
          delay: 2500,
        },
      },
    },

    on: {
      init(swiper) {
        swiper.update();
      },
    },
  });
}